import { Toaster as Sonner, toast } from "sonner"
import { useStore } from "../../store/useStore"
import { useIsMobile } from "../../hooks/useIsMobile"

/* Tema y posición de los avisos (A24, auditoría 2026-10-02). Usaba useTheme() de next-themes
   sin su ThemeProvider: los avisos iban siempre con el tema del sistema, no con el de Orvian.
   En el móvil, abajo a la derecha quedaban debajo de la barra inferior y del pulgar. */
const Toaster = ({
  position,
  ...props
}) => {
  const theme = useStore((s) => s.theme) || "light"
  const mobile = useIsMobile()

  return (
    <Sonner
      theme={theme}
      position={mobile && position === "bottom-right" ? "top-center" : position}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
